export default "__VITE_ASSET__CC$tS5MB__"